<form #formulari="ngForm">         
    <div i18n="@@DocumentsEstrangers1" >
        A tenir en compte en el cas d’estudis cursats a l’estranger:
    </div>        
    <div i18n="@@DocumentsEstrangers2">
        Tota documentació ha d’estar expedida en català, castellà o anglès, si no és així ha d’anar acompanyada de la corresponent traducció oficial al català o castellà.
    </div>
    <br>
    <p i18n>Tipus d'arxiu suportats: 'pdf', 'doc', 'jpg', 'docx', 'jpeg', 'png', 'odt', 'rtf'</p>
    <mat-grid-list cols="5" rowHeight="80px">       
        <div *ngFor="let doc of trasllat.documents">
            <mat-grid-tile colspan="2">
                <span class="pre-controls-right">
                    {{doc.tipusDocument.name}} <span *ngIf="doc.obligatori">*</span>
                </span>                            
            </mat-grid-tile>
            <mat-grid-tile *ngIf="trasllat.potModificar && doc.potModificar">
                <label role="button" class="mdl-button mdl-js-button mdl-button--raised" *ngIf="!doc.waiting">
                    <input type="file" (change)="filesSelect(doc, $event.target.files)" hidden>
                    <span *ngIf="!doc.nom" i18n>Puja</span>
                    <span *ngIf="doc.nom" i18n>Modifica</span>        
                </label>
                <span *ngIf="doc.waiting">
                        <p i18n>Pujant el fitxer...</p>
                        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                </span>                                                        
                <span *ngIf="doc.nom" role="button" class="mdl-button mdl-js-button mdl-button--raised" (click)="eliminaDocumentPreinscripcio(doc)" i18n>
                    Elimina
                </span>
            </mat-grid-tile>
            <mat-grid-tile colspan="2">
                <span class="pre-controls-left">
                    <small *ngIf="doc.nom">{{doc.nom}}</small>
                    <small *ngIf="!doc.nom">{{doc.descripcio}}</small>
                </span>
            </mat-grid-tile>                        
        </div>                
        <mat-grid-tile colspan="5">
            <div i18n>
                * Documents obligatoris. La resta de documents els podràs adjuntar en un altre moment però cal que tinguis en compte la sol·licitud no es resoldrà si no els hi adjuntes.
            </div>
        </mat-grid-tile>           
        <mat-grid-tile colspan="1">
            <div i18n="@@DocumentsNota1">
                Nota important:
            </div>
        </mat-grid-tile>           
        <mat-grid-tile colspan="4">
            <div i18n="@@DocumentsNota2">
                La Universitat de Girona, per mitjà de les Secretaries Acadèmiques dels Centres Docents, revisarà la documentació aportada i podrà requerir a l’estudiant, durant el procés d’admissió, qualsevol documentació que estigui incompleta o que tingui defectes de forma, així com qualsevol altra documentació que consideri necessària, dins el termini i forma que indiqui, amb el benentès que si no es lliura la documentació reclamada podrà suposar l’exclusió de la sol·licitud. Així mateix, la documentació incompleta pot impedir valorar algun criteri de selecció i, en conseqüència, pot afectar la puntuació final.
            </div>
        </mat-grid-tile>           
        <mat-grid-tile colspan="5" *ngIf="trasllat.potModificar">
            <div *ngIf="waiting">
                <p i18n>Processant la informació, espera un moment...</p>
                <mat-progress-bar mode="indeterminate"></mat-progress-bar>
            </div>            
            <div class="pre-controls-right" *ngIf="!waiting">
                <button mat-raised-button matStepperPrevious i18n>Torna</button>
                <button mat-raised-button color="primary" (click)="continua()" [disabled]="!isValid()" i18n>Continua</button>            
            </div>
        </mat-grid-tile>
    </mat-grid-list>                                
</form>



// WEBPACK FOOTER //
// ./src/app/documentacio/documentacio.component.html